/**
 * Lessor entity — V2 admin module.
 *
 * Mirrors the schema in supabase/migrations/20260429120000_lessors_table.sql.
 * Inlined here so V2 code can compile before src/integrations/supabase/types.ts
 * is regenerated against the develop schema. Once types are regenerated, the
 * `Lessor` type below should be replaced with `Database['public']['Tables']['lessors']['Row']`.
 */

export const LESSOR_TYPES = ["Company", "Individual", "GbR"] as const;
export type LessorType = (typeof LESSOR_TYPES)[number];

export type Lessor = {
  id: string;
  name: string;
  type: LessorType;
  address: string | null;
  city_postal: string | null;
  email: string | null;
  phone: string | null;
  rep_name: string | null;
  rep_role: string | null;
  rep_note: string | null;
  bank_holder: string | null;
  bank_iban: string | null;
  bank_bic: string | null;
  bank_name: string | null;
  /**
   * When true, this lessor is CoLiviq itself: its bank account is the default
   * platform (fee-collection) account. At most one lessor carries this flag.
   */
  is_platform: boolean;
  created_at: string;
  updated_at: string;
};

/** Shape submitted from the create / edit form (no auto-generated columns). */
export type LessorInput = Omit<Lessor, "id" | "created_at" | "updated_at">;
